import { Component } from '@angular/core';

@Component({
  selector: 'app-adventurer',
  standalone: true,
  imports: [],
  templateUrl: './adventurer.component.html',
  styleUrl: './adventurer.component.scss'
})
export class AdventurerComponent {

}
